import React from "react";

import {
  FormControl,
  FormLabel,
  Textarea,
} from "@chakra-ui/react";
import { Controller } from 'react-hook-form-7';

import useTranslations from '../../../../hooks/useTranslations';

import useTextInputFocus from '../../hooks/useTextInputFocus';

import { QuestionProps } from './types/QuestionProps';

const QuestionComment: React.FC<QuestionProps> = ({ control, path }) => {
  const t = useTranslations();
  const { onFocus, onBlur } = useTextInputFocus();

  return (
    <FormControl id={`${path}.comment`}>
      <FormLabel fontWeight="medium" fontSize="md" color="gray.600">
        {t("reports.edit.addComment")}
      </FormLabel>
      <Controller
        control={control}
        name={`${path}.comment` as const}
        shouldUnregister
        render={({ field: { onBlur: fieldBlur, ...fieldMethods } }) => (
          <Textarea
            placeholder={t("reports.edit.commentPlaceholder") as string}
            onFocus={onFocus()}
            onBlur={onBlur(fieldBlur)}
            {...fieldMethods}
          />
        )}
      />
    </FormControl>
  );
};

export default React.memo(QuestionComment);
